<template>
  <div>
    <a-row :gutter="[8, 8]">
      <a-col :span="6">
        <a-card title="今日销售额" size="small">
          <div style="text-align: center; font-size: 36px; font-weight: 600; color: #1890ff; margin: 12px 0;">
            {{ item.sales_amount }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card title="今日实收" size="small" hoverable style="cursor: pointer;" @click.native="openReceived">
          <div style="text-align: center; font-size: 36px; font-weight: 600; color: #1aa050; margin: 12px 0;">
            {{ item.received_amount || 0 }}
          </div>
          <div style="text-align: center; color: #8c8c8c; font-size: 12px;">
            现结 {{ item.cash_sales_amount || 0 }} · 收款 {{ item.cash_collection_amount || 0 }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card title="今日销售笔数" size="small">
          <div style="text-align: center; font-size: 36px; font-weight: 600; color: #1890ff; margin: 12px 0;">
            {{ item.sales_count }}
          </div>
        </a-card>
      </a-col>
      <a-col :span="6">
        <a-card title="今日采购笔数" size="small">
          <div style="text-align: center; font-size: 36px; font-weight: 600; color: #1890ff; margin: 12px 0;">
            {{ item.purchase_count }}
          </div>
        </a-card>
      </a-col>

      <a-col :span="24">
        <a-card title="待办事项" size="small">
          <a-card-grid style="width:20%; text-align:center; cursor: pointer;" @click="navigateTo('/warehouse/inStock')">
            <a-statistic title="待入库" :value="item.stock_in_task_count" />
          </a-card-grid>
          <a-card-grid
            style="width:20%; text-align:center; cursor: pointer;"
            @click="navigateTo('/warehouse/outStock')"
          >
            <a-statistic title="待出库" :value="item.stock_out_task_count" />
          </a-card-grid>
          <a-card-grid
            style="width:20%; text-align:center; cursor: pointer;"
            @click="navigateTo('/report/stock_report')"
          >
            <a-statistic title="库存预警" :value="item.inventory_warning_count" />
          </a-card-grid>
          <a-card-grid
            style="width:20%; text-align:center; cursor: pointer;"
            @click="navigateTo('/finance/arrears_receivable')"
          >
            <a-statistic title="应收欠款" :value="item.arrears_receivable_amount" />
          </a-card-grid>
          <a-card-grid
            style="width:20%; text-align:center; cursor: pointer;"
            @click="navigateTo('/finance/arrears_payable')"
          >
            <a-statistic title="应付欠款" :value="item.arrears_payable_amount" />
          </a-card-grid>
        </a-card>
      </a-col>

      <a-col :span="12">
        <sales-trend />
      </a-col>

      <a-col :span="12">
        <sales-goods />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { homeOverview } from '@/api/statistic'

export default {
  components: {
    SalesTrend: () => import('./salesTrend.vue'),
    SalesGoods: () => import('./salesGoods.vue'),
  },
  data() {
    return {
      loading: false,
      item: {},
    }
  },
  methods: {
    initialize() {
      this.list()
    },
    list() {
      this.loading = true
      homeOverview()
        .then((data) => {
          this.item = data
        })
        .finally(() => {
          this.loading = false
        })
    },
    navigateTo(pathName) {
      this.$router.push({ path: pathName })
    },
    openReceived() {
      const start = new Date()
      const end = new Date(start)
      end.setDate(end.getDate() + 1)
      const fmt = (date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${date.getFullYear()}-${month}-${day}`
      }
      this.$router.push({
        path: '/report/received_detail',
        query: { kind: 'all', start_date: fmt(start), end_date: fmt(end) },
      })
    },
  },
  mounted() {
    this.initialize()
  },
}
</script>

<style scoped></style>
